import SignOut from '~/components/GlobalHeader/Shared/components/SignOut';
import { MENU_KEYS } from '../../../config/constants';
import { TRIGGER_TYPE } from '@mindtickle/actions-dropdown';
import { MIXPANEL_EVENTS } from '../../../mixpanel/config';
import ViewProfile from '../ViewProfile';
import { ProfileMenuArgType } from '~/components/GlobalHeader/Shared/type';

export const PROFILE_MENU_OPTIONS = ({
  company,
  logout,
  user,
  track,
  onHideDropdownContent,
}: ProfileMenuArgType) => ({
  [MENU_KEYS.PROFILE]: {
    key: MENU_KEYS.PROFILE,
    content: (
      <ViewProfile
        user={user}
        company={company}
        eventName={MIXPANEL_EVENTS.LEARNER_PROFILE_VIEWED}
        track={track}
        onHideDropdownContent={onHideDropdownContent}
      />
    ),
    triggerType: TRIGGER_TYPE.COMPONENT,
    overrideItemStyle: true,
    showBottomBorder: true,
  },
  [MENU_KEYS.LOGOUT]: {
    key: MENU_KEYS.LOGOUT,
    content: <SignOut logout={logout} track={track} eventName={MIXPANEL_EVENTS.LOGOUT} />,
    triggerType: TRIGGER_TYPE.COMPONENT,
  },
});
